<template>
  <main id="main">
    <div style="height: 45vh" class="bg_light_theme w-100 rounded_div position-relative">
      <div class="w-100 h-100 d-flex justify-content-center align-items-center">
        <img src="@/assets/imgs/ayendaman-pic-1.png" class="logo" alt="">
      </div>
    </div>
    <div class="p-3">
      <p class="text-center font_large bold mb-4 mt-2">{{ t('register_app') }}</p>
      <div class="d-flex align-items-start justify-content-center" @click="openChoiceModal">
        <div class="position-relative">
          <p style="right: -9rem; white-space: nowrap;" class="position-absolute bold font_small">{{ t('select_pic_type') }}</p>
          <img style="bottom: -.5rem; right: -.5rem; z-index: 1;" src="@/assets/imgs/edit.svg" class="icon-size-5 position-absolute" alt="">
          
          <div v-if="isUploading" class="position-absolute w-100 h-100 rounded-pill bg-dark opacity-50 d-flex justify-content-center align-items-center text-white" style="z-index: 2;">
            ...
          </div>

          <img style="width: 7rem; height: 7rem; object-fit: cover;" :src="profileImageUrl" class="rounded-pill border_theme shadow_input" alt="">
          <input type="file" ref="fileInput" @change="onFileSelected" style="display: none" accept="image/*">
        </div>
      </div>
      
      <div class="d-flex align-items-center justify-content-between gap-3 mb-3">
        <div class="w-50">
          <label class="pe-3" for="name">{{ t('name') }}</label>
          <input class="p-4 w-100 rounded-pill" id="name" type="text" v-model="form.name">
        </div>
        <div class="w-50">
          <label class="pe-3" for="family">{{ t('family') }}</label>
          <input class="p-4 w-100 rounded-pill" id="family" type="text" v-model="form.family">
        </div>
      </div>

      <div class="d-flex align-items-center justify-content-between gap-3 mb-3">
        <div class="w-50">
          <label class="pe-3" for="father_name">{{ t('father_name') }}</label>
          <input class="p-4 w-100 rounded-pill" id="father_name" type="text" v-model="form.father_name">
        </div>
        <div class="w-50">
          <label class="pe-3" for="father_family">{{ t('father_family') }}</label>
          <input class="p-4 w-100 rounded-pill" id="father_family" type="text" v-model="form.father_family">
        </div>
      </div>

      <div class="d-flex align-items-center justify-content-between gap-3 mb-3">
        <div class="w-50 position-relative">
          <label class="pe-3">{{ t('country') }}</label>
          <div class="custom-select-box p-3 w-100 rounded-pill d-flex align-items-center justify-content-between" @click="showCountryModal = true">
            <div class="d-flex align-items-center gap-2 overflow-hidden">
              <img v-if="selectedCountryObj" :src="selectedCountryObj.pic" class="option-icon" alt="">
              <span v-if="form.country" class="text-truncate">{{ form.country }}</span>
              <span v-else class="text-muted small">{{ t('click_to_select') }}</span>
            </div>
            <i class="arrow-down">▼</i>
          </div>
        </div>

        <div class="w-50">
          <label class="pe-3" for="age">{{ t('age') }}</label>
          <input class="p-4 w-100 rounded-pill" id="age" type="text" v-model="form.age">
        </div>
      </div>

      <div class="d-flex align-items-center justify-content-between gap-3 mb-3">
        <div class="w-50">
          <label class="pe-3" for="ref_code">کد معرفی</label>
          <input class="p-4 w-100 rounded-pill" id="ref_code" type="text" v-model="form.ref_code">
        </div>
        
        <div class="w-50 position-relative">
          <label class="pe-3">صنف تعلیمی</label>
          <div class="custom-select-box p-3 w-100 rounded-pill d-flex align-items-center justify-content-between" @click="showGradeModal = true">
            <div class="d-flex align-items-center gap-2 overflow-hidden">
              <img v-if="selectedGradeObj" :src="selectedGradeObj.pic" class="option-icon" alt="">
              <span v-if="selectedGradeObj" class="text-truncate">{{ selectedGradeObj.title }}</span>
              <span v-else class="text-muted small">{{ t('click_to_select') }}</span>
            </div>
            <i class="arrow-down">▼</i>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-center align-items-center mt-3 mb-6">
        <button class="button" @click="submitRegister" :disabled="loading || isUploading" :style="(loading || isUploading) ? 'opacity: 0.7' : ''">
          <span v-if="isUploading">{{ t('uploading') }}</span>
          <span v-else-if="loading">{{ t('loading') }}</span>
          <span v-else>{{ t('submit_continue') }}</span>
        </button>
      </div>
    </div>
    <div class="w-100 max_width d-flex justify-content-end position-fixed bottom-3 p-3" style="pointer-events: none;">
      <img src="@/assets/imgs/whatsapp.svg" class="icon-size-8 cursor-pointer" alt="" style="pointer-events: auto;" @click="openWhatsApp">
    </div>

    <!-- Country Selection Modal -->
    <div v-if="showCountryModal" class="modal_overlay" @click.self="showCountryModal = false">
      <div class="modal_content bg_white rounded-4 p-4 shadow_box w-90" style="max-height: 70vh; display: flex; flex-direction: column;">
        <p class="text-center bold mb-3 font_medium">{{ t('country') }}</p>
        <div class="overflow-auto mb-3 flex-grow-1" style="border: 1px solid #eee; border-radius: 10px;">
          <div 
             v-for="c in countries" 
             :key="c.id" 
             @click="tempSelectedCountry = c"
             class="d-flex align-items-center gap-3 p-3 border-bottom cursor-pointer transition-bg"
             :class="{'bg_light_theme text_white': tempSelectedCountry && tempSelectedCountry.id === c.id}"
          >
             <img :src="c.pic" class="option-icon" alt="">
             <span class="bold">{{ c.title }}</span>
          </div>
        </div>
        <button class="button w-100" @click="confirmCountry" :disabled="!tempSelectedCountry">{{ t('confirm') }}</button>
      </div>
    </div>

    <!-- Grade Selection Modal -->
    <div v-if="showGradeModal" class="modal_overlay" @click.self="showGradeModal = false">
      <div class="modal_content bg_white rounded-4 p-4 shadow_box w-90" style="max-height: 70vh; display: flex; flex-direction: column;">
        <p class="text-center bold mb-3 font_medium">صنف تعلیمی</p>
        <div class="overflow-auto mb-3 flex-grow-1" style="border: 1px solid #eee; border-radius: 10px;">
          <div 
             v-for="g in grades" 
             :key="g.id" 
             @click="tempSelectedGrade = g"
             class="d-flex align-items-center gap-3 p-3 border-bottom cursor-pointer transition-bg"
             :class="{'bg_light_theme text_white': tempSelectedGrade && tempSelectedGrade.id === g.id}"
          >
             <img :src="g.pic" class="option-icon" alt="">
             <span class="bold">{{ g.title }}</span>
          </div>
        </div>
        <button class="button w-100" @click="confirmGrade" :disabled="!tempSelectedGrade">{{ t('confirm') }}</button>
      </div>
    </div>

    <div v-if="showErrorModal" class="modal_overlay">
      <div class="modal_content">
        <p class="text-center font_normal mb-5 line_height_2 px-2 mt-2">{{ errorMessage }}</p>
        <button class="button w-100" @click="showErrorModal = false">{{ t('understand') }}</button>
      </div>
    </div>

    <div v-if="showChoiceModal" class="modal_overlay" @click.self="showChoiceModal = false">
      <div class="modal_content">
        <p class="text-center font_large bold mb-4">{{ t('select_pic_type') }}</p>
        <div class="d-flex flex-column gap-3 w-100">
          <button class="button w-100" @click="openAvatarSelector">{{ t('local_avatar') }}</button>
          <button class="button w-100" @click="selectFromGallery">{{ t('gallery_select') }}</button>
        </div>
      </div>
    </div>

    <div v-if="showAvatarModal" class="modal_overlay" @click.self="cancelAvatarSelection">
      <div class="modal_content modal_content_avatars">
        <p class="text-center font_large bold mb-4">{{ t('local_avatar') }}</p>
        <div class="avatar-grid mb-4">
          <img 
            v-for="(avatar, index) in avatars" 
            :key="index" 
            :src="avatar.path" 
            class="avatar-item"
            :class="{ 'selected': selectedAvatar && selectedAvatar.path === avatar.path }"
            @click="selectAvatar(avatar)"
          />
        </div>
        <div class="d-flex justify-content-center gap-3 w-100">
          <button class="button w-50" :disabled="!selectedAvatar" :class="{'button-disabled': !selectedAvatar}" @click="confirmAvatarSelection">{{ t('confirm') }}</button>
          <button class="button w-50 bg_gray" @click="cancelAvatarSelection">{{ t('cancel') }}</button>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import apiClient, { createFormData } from '@/services/api'
import { Decryption } from '@/utils/crypto'

export default {
  name: 'RegisterView',
  data() {
    return {
      profileImageUrl: require('@/assets/imgs/NoPath.svg'),
      uploadedFileName: '',
      isUploading: false,
      countries: [],
      grades: [],
      loading: false,
      
      // Modal Controls
      showCountryModal: false,
      showGradeModal: false,
      tempSelectedCountry: null,
      tempSelectedGrade: null,

      showErrorModal: false,
      errorMessage: '',
      showChoiceModal: false,
      showAvatarModal: false,
      avatars: [],
      selectedAvatar: null,
      form: {
        name: '',
        family: '',
        father_name: '',
        father_family: '',
        country: '',
        age: '',
        ref_code: '',
        grade_id: ''
      }
    }
  },
  computed: {
    selectedCountryObj() {
      return this.countries.find(c => c.title === this.form.country)
    },
    selectedGradeObj() {
      return this.grades.find(g => g.id === this.form.grade_id)
    }
  },
  async mounted() {
    this.loadLocalAvatars();
    try {
      const userId = localStorage.getItem('user_id');
      
      const countryData = createFormData({ action: 'country', user_id: userId })
      const resCountry = await apiClient.post('/public_info', countryData)
      
      if (Array.isArray(resCountry.data)) {
        this.countries = resCountry.data
      } else if (resCountry.data.status === true || resCountry.data.status === 'ok' || resCountry.data.data) {
        let rawData = resCountry.data.data || resCountry.data
        if (typeof rawData === 'string') {
          this.countries = Decryption(rawData)
        } else {
          this.countries = rawData
        }
      }

      const gradeData = createFormData({ action: 'grade', user_id: userId })
      const resGrade = await apiClient.post('/public_info', gradeData)
      
      if (Array.isArray(resGrade.data)) {
        this.grades = resGrade.data
      } else if (resGrade.data.status === true || resGrade.data.status === 'ok' || resGrade.data.data) {
        let rawData = resGrade.data.data || resGrade.data
        if (typeof rawData === 'string') {
          this.grades = Decryption(rawData)
        } else {
          this.grades = rawData
        }
      }
    } catch (error) {
      console.error('MOUNTED ERROR:', error)
    }
  },
  methods: {
    loadLocalAvatars() {
      try {
        const requireContext = require.context('@/assets/avatar', false, /\.(png|jpe?g|svg)$/);
        this.avatars = requireContext.keys().map(file => {
          return {
            path: requireContext(file),
            name: file.replace('./', '')
          }
        });
      } catch (e) {
        console.error('Avatar load error:', e);
        this.avatars = [];
      }
    },
    openChoiceModal() {
      if (!this.isUploading) {
        this.showChoiceModal = true;
      }
    },
    selectFromGallery() {
      this.showChoiceModal = false;
      this.$refs.fileInput.click();
    },
    openAvatarSelector() {
      this.showChoiceModal = false;
      this.showAvatarModal = true;
    },
    selectAvatar(avatar) {
      this.selectedAvatar = avatar;
    },
    cancelAvatarSelection() {
      this.showAvatarModal = false;
      this.selectedAvatar = null;
    },
    async confirmAvatarSelection() {
      if (!this.selectedAvatar) return;
      try {
        const response = await fetch(this.selectedAvatar.path);
        const blob = await response.blob();
        const file = new File([blob], this.selectedAvatar.name, { type: blob.type });
        await this.uploadFile(file);
        this.showAvatarModal = false;
        this.selectedAvatar = null;
      } catch (error) {
        this.notify(this.t('error_submit'), 'error');
      }
    },
    onFileSelected(event) {
      const file = event.target.files[0];
      this.uploadFile(file);
    },
    async uploadFile(file) {
      if (file) {
        this.isUploading = true;

        const reader = new FileReader();
        reader.onload = e => { this.profileImageUrl = e.target.result; };
        reader.readAsDataURL(file);

        const formData = new FormData();
        formData.append('pic', file);
        formData.append('apikey', '4f3d2a9b7c1e5d6f8a0b9c3d2e4f6a7b');

        try {
          const res = await apiClient.post('/upload_pic', formData);
          if (res.data.status === 'ok') {
            this.uploadedFileName = res.data.pic_name;
          } else {
            this.notify(this.t('upload_error'), 'error');
          }
        } catch (e) {
          this.notify(this.t('upload_error'), 'error');
        } finally {
          this.isUploading = false;
        }
      }
    },
    confirmCountry() {
        if (this.tempSelectedCountry) {
            this.form.country = this.tempSelectedCountry.title;
            this.showCountryModal = false;
        }
    },
    confirmGrade() {
        if (this.tempSelectedGrade) {
            this.form.grade_id = this.tempSelectedGrade.id;
            this.showGradeModal = false;
        }
    },
    async submitRegister() {
      if (this.isUploading) {
        return
      }

      if (!this.uploadedFileName) {
        this.errorMessage = 'لطفاً برای ادامه یک عکس پروفایل برای خود انتخاب کنید'
        this.showErrorModal = true
        return
      }

      if (!this.form.name) {
        this.errorMessage = 'لطفاً برای ادامه بخش نام را پر کن .'
        this.showErrorModal = true
        return
      }

      if (!this.form.family) {
        this.errorMessage = 'لطفاً برای ادامه بخش تخلص را پر کن .'
        this.showErrorModal = true
        return
      }

      if (!this.form.father_name) {
        this.errorMessage = 'لطفاً برای ادامه بخش نام پدر را پر کن .'
        this.showErrorModal = true
        return
      }

      if (!this.form.father_family) {
        this.errorMessage = 'لطفاً برای ادامه بخش تخلص پدر را پر کن .'
        this.showErrorModal = true
        return
      }

      if (!this.form.country) {
        this.errorMessage = 'لطفاً برای ادامه بخش کشور را پر کن .'
        this.showErrorModal = true
        return
      }

      if (!this.form.age) {
        this.errorMessage = 'لطفاً برای ادامه بخش سن را پر کن .'
        this.showErrorModal = true
        return
      }

      if (!this.form.grade_id) {
        this.errorMessage = 'لطفاً برای ادامه بخش صنف تعلیمی را پر کن .'
        this.showErrorModal = true
        return
      }

      this.loading = true
      const currentUserId = localStorage.getItem('user_id')
      
      try {
        const signupData = createFormData({
          user_id: currentUserId,
          name: this.form.name,
          family: this.form.family,
          email: localStorage.getItem('user_email'),
          father_name: this.form.father_name,
          father_family: this.form.father_family,
          country: this.form.country,
          age: this.form.age,
          grade_id: this.form.grade_id,
          ref_code: this.form.ref_code,
          pic: this.uploadedFileName,
          language: localStorage.getItem('app_lang') || 'fa'
        })

        const res = await apiClient.post('/signup', signupData)

        if (res.data.status === 'ok') {
          let newUserId = null
          
          if (res.data.data && res.data.data.user_id) {
             newUserId = res.data.data.user_id
          } else if (res.data.data && res.data.data.id) {
             newUserId = res.data.data.id
          } else if (res.data.data && res.data.data.user_info && res.data.data.user_info.id) {
             newUserId = res.data.data.user_info.id
          } else if (res.data.user_id) {
             newUserId = res.data.user_id
          }

          if (newUserId) {
            localStorage.setItem('user_id', newUserId)
          }

          if (this.uploadedFileName) {
             const baseUrl = 'https://back.ayendaman.org/storage/app/public/uploads/'
             const fullPicUrl = baseUrl + this.uploadedFileName
             localStorage.setItem('temp_profile_pic', fullPicUrl)
          }

          setTimeout(() => {
            this.$router.push({ name: 'Home' })
          }, 500)
        } else {
          this.notify(res.data.message || this.t('error_submit'), 'error')
        }
      } catch (error) {
        if (error.response && error.response.data && error.response.data.message) {
          this.notify(error.response.data.message, 'error')
        } else {
          this.notify(this.t('connection_error'), 'error')
        }
      } finally {
        this.loading = false
      }
    },
    async openWhatsApp() {
      try {
        const formData = createFormData({ action: 'whatsapp' })
        const response = await apiClient.post('/public_info', formData)
        
        let url = ''
        if (typeof response.data === 'string') {
           url = response.data
        } else if (response.data.data) {
           url = response.data.data
        }
        
        if (url) {
           url = url.replace(/"/g, '')
           window.open(url, '_blank')
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style scoped>
.rounded_div {
  border-bottom-left-radius: 5rem;
  border-bottom-right-radius: 5rem;
}
.logo {
  width: 25rem;
}
.custom-select-box {
  background-color: #fff;
  border: 1px solid #ddd;
  min-height: 58px;
  cursor: pointer;
}
.option-icon {
  width: 25px;
  height: 25px;
  object-fit: contain;
  border-radius: 50%;
}
.cursor-pointer {
  cursor: pointer;
}
.arrow-down {
  font-size: 0.8rem;
  color: #666;
}
.modal_overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal_content {
  background-color: white;
  width: 85%;
  max-width: 25rem;
  border-radius: 2.5rem;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
}
.modal_content_avatars {
  max-width: 35rem; /* Increased width */
  width: 90%;
  max-height: 80vh;
}
.line_height_2 {
  line-height: 2rem;
}
.avatar-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* Changed to 3 columns to make items bigger */
  gap: 1.5rem; /* Increased gap */
  width: 100%;
  max-height: 50vh;
  overflow-y: auto;
  padding: 0.5rem;
}
.avatar-item {
  width: 100%;
  aspect-ratio: 1 / 1;
  object-fit: cover;
  border-radius: 50%;
  border: 3px solid transparent;
  cursor: pointer;
  transition: border-color 0.2s;
}
.avatar-item:hover {
  border-color: #ccc;
}
.avatar-item.selected {
  border-color: #4A00E0;
}
.button-disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background: #ccc !important;
  box-shadow: none !important;
}
.bg_gray {
  background: #a0a0a0 !important;
  box-shadow: none !important;
}
.transition-bg {
    transition: background-color 0.2s;
}
.transition-bg:hover {
    background-color: #f8f9fa;
}
.bg_light_theme {
    background-color: #4A00E0 !important;
}
.text_white {
    color: white !important;
}
</style>